import { createStyles, makeStyles } from "@material-ui/core";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import React, { useState } from "react";
import { ColumnModel, PageInfoModel } from "../../../models/common.model";
import { GetSalesSearchResponse } from "../../../models/sale.model";

const columns: readonly ColumnModel[] = [
  { id: "sellerName", label: "فروشنده / شعبه" },
  { id: "customerName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی متقاضی" },
  { id: "customerMobileNumber", label: "شماره همراه" },
  { id: "saleDatePersian", label: "تاریخ فروش" },
  { id: "factorDatePersian", label: "تاریخ بارگزاری فاکتور" },
  {
    id: "totalAmount",
    label: "مبلغ فاکتور (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  { id: "settlementDatePersian", label: "تاریخ تسویه" },
  { id: "settlerFullName", label: "تسویه کننده" },
  { id: "saleType", label: "نوع فروش" },
  { id: "saleStatusTitle", label: "وضعیت" },
];
interface Props {
  saleFactorsList: GetSalesSearchResponse[];
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handleClick: Function;
}
const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src='images/Next.png'
      alt=''
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src='images/Previous.png'
      alt=''
    />
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);

const SalesFactorTable = ({
  currentPaginationInfo,
  pageInfo,
  saleFactorsList,
  setCurrentPaginationInfo,
  handleClick,
}: Props) => {
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const classes = useStyles();
  // handlers
  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };

  const handleChangePagination = (event: any, value: any) => {
    setSelectedRow(0);
    changePageNumber(value);
  };
  return (
    <div>
      <div>
        <div className='cardTableBorder'>
          <TableContainer
            style={{ background: "#fff", maxHeight: "55vh" }}
            className='boxScroll'
          >
            <Table
              stickyHeader
              aria-label='sticky table'
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={selectedRow === 0}
                >
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight WidthRowNumber'
                    align='right'
                    style={{ width: "10vh", minWidth: "10vh" }}
                  >
                    ردیف
                  </TableCell>

                  {columns.map((column) => (
                    <TableCell
                      className='rowTHead colorTitle textFont12 fontWeight noWrap'
                      key={column.id}
                      align='right'
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {saleFactorsList
                  ? saleFactorsList?.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft cursorPointer noWrap`}
                          hover
                          role='checkbox'
                          tabIndex={-1}
                          key={row.key}
                          selected={selectedRow === rowIndex}
                          onClick={() => {
                            setSelectedRow(rowIndex);
                            handleClick(row.key);
                          }}
                        >
                          <TableCell
                            className='textFont12 WidthRowNumber'
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell>
                          {columns.map((column) => {
                            const value =
                              row[column.id as keyof GetSalesSearchResponse];
                            return (
                              <>
                                <TableCell
                                  className='textFont12'
                                  key={column.id}
                                  align='right'
                                  style={
                                    column.id === "saleStatusTitle"
                                      ? {
                                          color:
                                            row.saleStatus === "Settled"
                                              ? "#01AF43"
                                              : row.saleStatus ===
                                                "RejectedBySetad"
                                              ? "#E6123D"
                                              : "#FB8C00",
                                        }
                                      : {}
                                  }
                                >
                                  {!value ? (
                                    <>--</>
                                  ) : column.format && column.hasFormat ? (
                                    column.format(value)
                                  ) : (
                                    value?.toString()
                                  )}
                                </TableCell>
                              </>
                            );
                          })}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <Grid container spacing={2} alignItems='center'>
            <Grid
              item
              xs={12}
              sm={4}
              display='flex'
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                sx={{
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                }}
                count={
                  pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={12} sm={4}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default SalesFactorTable;
